import React, { useState } from 'react';

function Tutorial() {
  const [activeTab, setActiveTab] = useState(1);

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>[ 튜토리얼 ] ( •ᴗ• )و</h2>

      {/* 🎥 튜토리얼 비디오 */}
      <div style={styles.videoWrapper}>
        <video
          src="/tutorial.mp4"
          autoPlay
          loop
          muted
          playsInline
          style={styles.video}
        />
      </div>

      {/* 🖤 노티스 박스 */}
      <section style={styles.notice}>
        <p style={styles.noticeText}>
          안녕하세요! 지금은 앱 초기라 등록된 계단이 아직 많지 않아요!<br />
          저 혼자 모든 역을 다니면서 계단을 확인하기가 힘들어서…<br />
          지하철에서 계단이 보이면 꼭 기록해주시거나<br />
          &quot;새 계단 등록&quot;으로 도와주시면 정말 큰 힘이 됩니다!<br />
          함께 만들면 더 빨리 좋아져요 ( •ᵕ• )و ✧<br />
          <br />
          무브 오브 투데이, 창훈 올림
        </p>
      </section>

      {/* 🔽 탭 버튼 */}
      <div style={styles.tabBar}>
        <button
          type="button"
          onClick={() => setActiveTab(1)}
          style={{
            ...styles.tabButton,
            ...(activeTab === 1 ? styles.tabButtonActive : {}),
          }}
        >
          ① 계단 기록
        </button>
        <button
          type="button"
          onClick={() => setActiveTab(2)}
          style={{
            ...styles.tabButton,
            ...(activeTab === 2 ? styles.tabButtonActive : {}),
          }}
        >
          ② 새 계단 등록
        </button>
        <button
          type="button"
          onClick={() => setActiveTab(3)}
          style={{
            ...styles.tabButton,
            ...(activeTab === 3 ? styles.tabButtonActive : {}),
          }}
        >
          ③ 홈화면에 추가
        </button>
      </div>

      {/* 탭 1 : 계단 기록 하기 */}
      {activeTab === 1 && (
        <>
          <section style={styles.section}>
            <h3 style={styles.sectionTitle}>① 계단 찾기</h3>
            <ul style={styles.list}>
              <li>지하철 출근 / 퇴근 길에 계단 근처에서 앱을 열어주세요.</li>
              <li>GPS 로 100m 안에 있는 계단을 자동으로 찾아줘요.</li>
              <li>리스트에서 실제로 올라간 계단을 골라 주세요.</li>
            </ul>
          </section>

          <section style={styles.section}>
            <h3 style={styles.sectionTitle}>② 기록 남기기</h3>
            <ul style={styles.list}>
              <li>계단을 선택하고 실제 계단 사진을 찍어 주세요.</li>
              <li>같은 계단은 10분에 한 번만 기록돼요 (쿨타임).</li>
              <li>기록하면 &quot;나의 통계&quot;와 랭킹에 바로 반영됩니다.</li>
            </ul>
          </section>

          <section style={styles.section}>
            <h3 style={styles.sectionTitle}>③ 그룹 &amp; 랭킹 활용</h3>
            <ul style={styles.list}>
              <li>&quot;그룹&quot;에서 회사 / 모임 계단 그룹을 만들 수 있어요.</li>
              <li>대표 그룹을 설정하면 홈 화면에 같이 보여요.</li>
              <li>&quot;RANKING&quot; 탭에서 전체 / 그룹별 순위를 볼 수 있어요.</li>
            </ul>
          </section>
        </>
      )}

      {/* 탭 2 : 새 계단 등록 하기 */}
      {activeTab === 2 && (
        <section style={styles.section}>
          <h3 style={styles.sectionTitle}>② 새 계단 등록 하기</h3>
          <p style={styles.text}>
            아직 등록되지 않은 계단을 발견하셨다면,<br />
            꼭 &quot;새 계단 등록&quot;으로 도와주세요! (ง •̀_•́)ง
          </p>
          <ul style={styles.list}>
            <li>
              1단계 – 계단 근처에서 앱을 열고 &quot;계단 기록하기&quot; 화면
              맨 아래의 <strong>[ 새 계단 등록하기 ]</strong> 버튼을 눌러요.
            </li>
            <li>2단계 – 계단 이름, 지하철역 이름, 계단 수(대략도 괜찮아요)를 입력해요.</li>
            <li>3단계 – 실제 계단이 잘 보이게 사진을 찍어 업로드합니다.</li>
            <li>4단계 – 제출하면 관리자가 확인 후 공식 계단으로 등록해요.</li>
          </ul>
          <p style={styles.textSmall}>
            ※ 지하철역 계단 위주로 받고 있어요. <br />
            ※ 거짓/장난 제안은 다른 유저들에게도 피해가 가니 꼭 실제 계단만 부탁드려요!
          </p>
        </section>
      )}

      {/* 탭 3 : 웹 홈화면에 추가하기 */}
      {activeTab === 3 && (
        <section style={styles.section}>
          <h3 style={styles.sectionTitle}>③ 웹 홈화면에 추가하기</h3>
          <p style={styles.text}>
            자주 쓰려면 폰 홈 화면에 바로가기를 만들어 두면 편해요 (๑˃̵ᴗ˂̵)و
          </p>

          <h4 style={styles.subTitle}> 안드로이드 (크롬)</h4>
          <ul style={styles.list}>
            <li>1) 크롬으로 출퇴근 계단 앱 주소를 열어둡니다.</li>
            <li>2) 오른쪽 위 ⋮ 버튼을 눌러요.</li>
            <li>3) 메뉴에서 &quot;홈 화면에 추가&quot; 를 선택합니다.</li>
            <li>4) 이름을 확인하고 &quot;추가&quot;를 누르면 아이콘이 생겨요.</li>
          </ul>

          <h4 style={styles.subTitle}> iOS (사파리)</h4>
          <ul style={styles.list}>
            <li>1) 사파리로 출퇴근 계단 앱 주소를 엽니다.</li>
            <li>2) 아래쪽 공유 아이콘(⬆︎ 화살표 있는 네모)을 눌러요.</li>
            <li>3) 스크롤해서 &quot;홈 화면에 추가&quot; 를 선택합니다.</li>
            <li>4) 이름을 확인하고 &quot;추가&quot;를 누르면 홈 화면에 아이콘이 생깁니다.</li>
          </ul>

          <h4 style={styles.subTitle}> PC / 노트북</h4>
          <ul style={styles.list}>
            <li>주소창 옆 별표(★)로 즐겨찾기에 넣어 두면 빨리 열 수 있어요.</li>
          </ul>
        </section>
      )}

      <p style={styles.footer}>오늘도 천천히, 하지만 꾸준하게✧</p>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: '700px',
    margin: '0 auto',
    padding: '20px',
  },
  title: {
    fontSize: '22px',
    fontWeight: 'bold',
    marginBottom: '20px',
    borderBottom: '1px solid #000',
    paddingBottom: '8px',
  },

  videoWrapper: {
    width: '100%',
    padding: '0px 0 8px',
  },
  video: {
    width: '100%',
    backgroundColor: '#f5f5f5',
  },

  notice: {
    backgroundColor: '#000000',
    padding: '14px 16px',
    marginTop: '4px',
    marginBottom: '18px',
    color: '#ffffff',
  },
  noticeText: {
    fontSize: '14px',
    lineHeight: 1.6,
    fontWeight: '500',
    textIndent: '1em',
  },

  tabBar: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '6px',
    marginBottom: '16px',
  },
  
  tabButton: {
    flex: 1,                 // ← 버튼 폭 동일 비율
    height: '42px',          // ← 버튼 높이 고정 (원하는 값으로 조정 가능)
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',    // ← 텍스트 세로 가운데 정렬
    padding: '0',
    fontSize: '13px',
    border: '1px solid #ccc',
    backgroundColor: '#f8f8f8',
    cursor: 'pointer',
    whiteSpace: 'nowrap',    // 텍스트 줄바꿈 방지
  },
  
  tabButtonActive: {
    fontWeight: '600',
    borderColor: '#000',
    backgroundColor: '#000',
    color: '#fff',
  },
  

  section: {
    marginBottom: '18px',
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 'bold',
    marginBottom: '6px',
  },
  subTitle: {
    fontSize: '14px',
    fontWeight: '600',
    marginTop: '10px',
    marginBottom: '4px',
  },
  list: {
    margin: '4px 0 10px 0',
    paddingLeft: '18px',
    fontSize: '14px',
    lineHeight: 1.6,
    color: '#333',
  },
  text: {
    fontSize: '14px',
    color: '#333',
    lineHeight: 1.6,
  },
  textSmall: {
    fontSize: '12px',
    color: '#666',
    lineHeight: 1.6,
  },
  footer: {
    marginTop: '8px',
    fontSize: '13px',
    color: '#666',
  },
};

export default Tutorial;
